import { render } from "./vertical.vue?vue&type=template&id=64cc2888&scoped=true"
import script from "./vertical.vue?vue&type=script&lang=js"
export * from "./vertical.vue?vue&type=script&lang=js"

import "./vertical.vue?vue&type=style&index=0&id=64cc2888&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cc2888"]])

export default __exports__